export default "__VITE_ASSET__BgNh0tnd__"